import _ from "lodash";
import savePurcashingAccountsComponent from "../savePurchasingAccounts/savePurchasingAccounts.component";

class AdminPermissionsController {
  constructor(
    adminPermissionsService,
    userAccountService,
    customerIntegrationsService,
    modalLoaderService,
    contentLoaderService
  ) {
    this.name = "AdminPermissions";
    this.orgHierarchy = [];
    this.alertConfig = {
      type: "success",
      msg: "",
    };
    this.showAlert = false;
    this.isUpdateEnabled = false
    this.userAccountService = userAccountService;
    this.contentLoaderService = contentLoaderService;
    this.customerIntegrationsService = customerIntegrationsService;
    this.adminPermissionsService = adminPermissionsService;
    this.modalLoaderService = modalLoaderService;
    this.selectedAdmin = undefined;
    this.allAccountChecked = false;
    this.reset();
    this.getCustomerAdminsDetails();
  }

  getExistingAccountsAndOrgHierarchy() {
    if (this.customer && this.customer.id) {
      this.selectedPurchasingAccounts = [];
      this.isLoading = true;
      this.processed = 0;
      this.adminPermissionsService
        .getPurchasingAccountsByCustomerId(this.customer.id)
        .then((purchasingAccountsResponse) => {
          this.isLoading = false;
          this.purchasingAccounts =
            (purchasingAccountsResponse && purchasingAccountsResponse.data && purchasingAccountsResponse.data.content && purchasingAccountsResponse.data.content.purchasingAccounts) ||
            [];
          this.contentLoaderService.hide();
          if (this.selectedAdministrator) {
            this.getUserAssignedAccounts()
          }
        }).catch((error) => {
          this.isLoading = false;
          this.contentLoaderService.hide();
        })
    }
  }

  onFailure(msg) {
    window.scrollTo(0, 0);
    this.alertConfig.type = "danger";
    this.alertConfig.msg = msg;
    this.showAlert = true;
  }

  updatePurchasingAccounts(e, cmd) {
    const id = e.target.value;
    switch (id) {
      case "all": {
        switch (cmd) {
          case "remove":
            this.selectedPurchasingAccounts = [];
            this.removePurchasingAccounts = this.existingPurchasingAccounts;
            break;
          case "add":
            this.selectedPurchasingAccounts = [...new Set([
              ...this.selectedPurchasingAccounts,
              ...this.purchasingAccounts.map(
                (purchasingAccount) => purchasingAccount.purchasingAccountNumber
              ),
            ])];
            this.removePurchasingAccounts = [];

            break;
        }
        break;
      }
      default: {
        switch (cmd) {
          case "remove":
            this.selectedPurchasingAccounts =
              this.selectedPurchasingAccounts.filter((a) => {
                return a !== id;
              });
            if (
              !this.removePurchasingAccounts.includes(id) &&
              this.existingPurchasingAccounts.includes(id)
            ) {
              this.removePurchasingAccounts.push(id);
            }
            break;
          case "add":
            this.removePurchasingAccounts =
              this.removePurchasingAccounts.filter((a) => {
                return a !== id;
              });
            if (!this.selectedPurchasingAccounts.includes(id)) {
              this.selectedPurchasingAccounts.push(id);
            }
            break;
        }
        break;
      }
    }
    this.updateButtonActiveInactive()
   
  }
  updateButtonActiveInactive(){
  let selectedPurchasingAccounts = this.selectedPurchasingAccounts.filter(
    (a) => !this.existingPurchasingAccounts.includes(a)
  );
  let removePurchasingAccounts = this.removePurchasingAccounts.filter((a) =>
    this.existingPurchasingAccounts.includes(a)
  );
  if(selectedPurchasingAccounts.length === 0 && removePurchasingAccounts.length === 0){
    this.isUpdateEnabled = false
  }else{
    this.isUpdateEnabled = true
  }
}
  savePurchasingAccounts() {
    let userPurchasingAccounts = {
      customer: this.customer,
      cachedPurchasingAccounts: this.createCachedPurchasingAccount(
        this.purchasingAccounts
      ),
      selectedPurchasingAccounts: this.selectedPurchasingAccounts.filter(
        (a) => !this.existingPurchasingAccounts.includes(a)
      ),
      removePurchasingAccounts: this.removePurchasingAccounts.filter((a) =>
        this.existingPurchasingAccounts.includes(a)
      ),
      selectedAdministrator: this.selectedAdministrator,
      allAccounts:
        this.selectedPurchasingAccounts.length > 0 &&
        this.purchasingAccounts.length ===
        this.selectedPurchasingAccounts.length,
      allAccountChecked: this.allAccountChecked,
      allPurchasingAccounts: this.purchasingAccounts,
    }
    this.addORremoveAccessAccounts(userPurchasingAccounts)
  }


  addORremoveAccessAccounts(userPurchasingAccounts) {
    let updateAccPayload
    if(userPurchasingAccounts.allAccounts){
      updateAccPayload = {
        allAccounts: true,
      }
    }else{
      if(userPurchasingAccounts.allAccountChecked){
        let selectedPurchasingAccounts = []
        userPurchasingAccounts.allPurchasingAccounts.map(account => {
          if(!userPurchasingAccounts.removePurchasingAccounts.some(acct => acct === account.purchasingAccountNumber)){
            selectedPurchasingAccounts.push(account.purchasingAccountNumber)
          }
        })
        updateAccPayload = {
          addPurchasingAccountList: selectedPurchasingAccounts,
          removePurchasingAccountList: userPurchasingAccounts.removePurchasingAccounts,
          allAccounts: false
        }
      }else{
        updateAccPayload = {
          addPurchasingAccountList: userPurchasingAccounts.selectedPurchasingAccounts,
          removePurchasingAccountList: userPurchasingAccounts.removePurchasingAccounts,
          allAccounts: false
        }
      }
    }
    this.alterCustomerAccounts(userPurchasingAccounts.customer.id, userPurchasingAccounts.selectedAdministrator, updateAccPayload).then(resp => {
      this.reset()
    }).catch(err => {
      this.reset()
    })   
    
  }

  alterCustomerAccounts(customerId, userId, updateAccPayload){
    return new Promise((resolve, reject) => {
      this.adminPermissionsService.addORremoveAccessAccounts(customerId, userId, updateAccPayload).then((response) => {
        resolve();
      }).catch((error) => {
        console.trace(error);
        console.log(error && error.data && error.data.message);
        reject();
      });
    });
  }

  reset() {
    if (this.customer && this.customer.rosterType) {
      this.isManual = _.toLower(this.customer.rosterType) === "manual";
    }
    if (!this.isManual) {
      this.processed = 0;
      this.isLoading = false;
      this.isUpdateEnabled = false
      this.purchasingAccounts = null;
      this.cachedPurchasingAccounts = {};
      this.selectedPurchasingAccounts = [];
      this.removePurchasingAccounts = [];
      this.existingPurchasingAccounts = [];
      this.allAccountChecked = false;
      this.contentLoaderService.show();
      this.getExistingAccountsAndOrgHierarchy();
    } else {
      this.processed = 1;
      this.isLoading = false;
      this.purchasingAccounts = [];
    }
  }

  getCustomerAdminsDetails() {
    if (this.customer && this.customer.id) {
      this.userAccountService
        .getCustomerAdminDetails(this.customer.id)
        .then(
          this.onGetUserDetailsSuccess.bind(this),
          this.onGetUserDetailsFailure.bind(this)
        );
    } else {
      this.isOverwriteSelected = true;
      this.adminWithPermissions = [];
      this.onFailure("Please select Customer");
    }
  }

  onGetUserDetailsSuccess(response) {
    this.adminWithPermissions = response.data.content;
  }

  onGetUserDetailsFailure() { }

  selectAdminForPermission(event) {
    this.isUpdateEnabled = false
    this.selectedAdministrator = event;
    this.getUserAssignedAccounts();
  }

  getUserAssignedAccounts() {
    let filteredCustomer=[];
    this.isLoading = true;
    this.contentLoaderService.show();
    this.adminPermissionsService
      .getAdministratorsAccounts(
        this.customer.id,
        this.selectedAdministrator
      )
      .then((userAccounts) => {
        this.isLoading = false;
        this.contentLoaderService.hide();
        if (userAccounts.data.content.allAccounts) {
          this.allAccountChecked = true;
          this.selectedPurchasingAccounts = this.purchasingAccounts.map(
            (acc) => acc.purchasingAccountNumber
          );
          this.existingPurchasingAccounts = this.purchasingAccounts.map(
            (acc) => acc.purchasingAccountNumber
          );
        } else {
          if (userAccounts &&
            userAccounts.data &&
            userAccounts.data.content &&
            userAccounts.data.content.purchasingAccounts) {
            const customerIntegrations = userAccounts.data.content.purchasingAccounts;
            filteredCustomer = customerIntegrations.filter((customerAccount) =>
              this.purchasingAccounts.some(
                (purchasingAccount) =>
                  purchasingAccount.purchasingAccountNumber ===
                  customerAccount.purchasingAccountNumber
              )
            );
          }

          this.selectedPurchasingAccounts = filteredCustomer.map((acc) => acc.purchasingAccountNumber)
          this.existingPurchasingAccounts = filteredCustomer.map((acc) => acc.purchasingAccountNumber)
        }
      })
  }

  createCachedPurchasingAccount(purchasingAccounts) {
    let cachedPurchasingAccounts = {};
    [].concat(this.selectedPurchasingAccounts, this.removePurchasingAccounts).forEach(id => {
      let account = purchasingAccounts.find(acc => acc.purchasingAccountNumber === id)
      cachedPurchasingAccounts[id] = {
        name: account.purchasingAccountName,
        oracleAccountId: account.oksAccountNumber || 'NON-OKS',
        id: account.purchasingAccountNumber
      }
    })
    return cachedPurchasingAccounts
  }
}

AdminPermissionsController.$inject = [
  "adminPermissionsService",
  "userAccountService",
  "customerIntegrationsService",
  "modalLoaderService",
  "contentLoaderService",
];

export default AdminPermissionsController;



// WEBPACK FOOTER //
// ./app/components/adminPermissions/adminPermissions.controller.js